let css = require('./order-state-filter.css');
const { Checkbox } = require('../../../../../../packages/account-ui');
const { setStatusFilterItem } = require('../../../../../../signals/account/orders-list');

class OrderStateFilter {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }
}

module.exports = {
    constructor: OrderStateFilter,
    children: [
        {
            name: 'checkbox',
            component: Checkbox,
            props: {
                signal: setStatusFilterItem
            },
            watcher: (attributes) => ({
                value: ['account', 'orders', 'list', 'stateFilter', attributes['cat-path'], 'isChecked']
            })
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/orders-navigation/order-state-collapser/order-state-filter/index.js